export const TiktokMobileFirst = () => {
    return (
        <div className="pt-[54px] pb-[20px] flex flex-col px-[53px]  [background:linear-gradient(135deg,rgba(235.51,245.26,255,1)_2.885%,rgba(185,242.42,250,1)_56.731%,rgba(110.34,201.36,255,1)_97.596%)] h-[390px]">
            <div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">TikTok全场景网络解决方案</div>
            <div className="flex gap-[20px] mt-[11px]">
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/tiktok/home-1.svg"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        TK全球直播加速专线
                    </div>
                </div>
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/tiktok/home-2.svg"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        TK全球中视频创作者基金
                    </div>
                </div>
            </div>

            <div className="flex gap-[40px] mt-[8px]">
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/tiktok/home-3.svg"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        TK短视频运营/养号
                    </div>
                </div>
                <div className="flex items-center gap-[8px]">
                    <img
                        src="/imgs/tiktok/home-4.svg"
                        className="w-[12px] h-[12px]"
                    />
                    <div className="text-[#333] text-[10px] font-regular ">
                        TK全球视频带货
                    </div>
                </div>
            </div>


            <div className="flex gap-[10px] mt-[16px]">
                <div className="w-[88px] h-[29.8px] flex flex-row justify-center items-center  rounded-[4px] [box-shadow:0px_2.8px_5.599999904632568px_0px_rgba(0,0,0,0.1)] [background:linear-gradient(135deg,rgba(100,183,255,1)_0%,rgba(137,171,255,1)_53.907%,rgba(185,155,255,1)_100%)]">
                    <div className="text-[12px] font-bold text-white">立即咨询</div>
                </div>

            </div>

            <div className="flex justify-center mt-[14px]">
                <img src="/imgs/tiktok/home.png" className="w-[246px] h-[163px]" />
            </div>
        </div>
    )
}